export enum EstateTaskUserTypeKey {
  RESEARCH = 'research',
  DATA_ENTRY = 'data_entry',
  FIRST_NOTIFICATIONS = 'first_notifications',
  DRAFT_PROBATE_OR_PETITION_APPLICATION = 'draft_probate_or_petition_application',
  ASSET_CHECKLIST = 'asset_checklist',
  DRAFT_INVENTORY_FORMS = 'draft_inventory_forms',
  DRAFTING_DISTRIBUTION_FORMS = 'drafting_distribution_forms',
  FILE_CLOSING = 'file_closing',
  CLIENT_COMMUNICATION = 'client_communication',
  REVIEW_MEETING = 'review_meeting',
  DOCUMENT_PREPARATION = 'document_preparation',
  NOTARY_BOOKING = 'notary_booking',
  UPDATE_OC_FAQ = 'update_oc_faq',
  CHARGEBACKS = 'chargebacks',
  PETITION_FOR_CLOSING = 'petition_for_closing',
  FILE_INTAKE = 'file_intake',
  CLIENT_MEETING = 'client_meeting',
  INTERNAL_COMMUNICATION = 'internal_communication',
  REVIEW_FILE_INFO = 'review_file_info',
  CONTACT_THIRD_PARTY = 'contact_third_party',
  MAIL_COURIER_EFILE_FAX = 'mail_courier_efile_fax',
  COURT_PROCESSES = 'court_processes',
  OFFICE_ADMINISTRATION = 'office_administration',
  BUG_VERIFICATION = 'bug_verification',
  OTHER = 'other',
  REVIEW_DOCUMENTS = 'review_documents',
  GENERATE_FROM_PLATFORM = 'generate_from_platform',
  TAX_DOCUMENTS = 'tax_documents',
  CLEARANCE_CERTIFICATE_PREP = 'clearance_certificate_prep',
  OC_COMMUNICATION = 'oc_communication',
  CREATE_EDITING_DOCUMENTS_FORMS = 'create_editing_documents_forms',
  GENERATE_WILL_AND_POA = 'generate_will_and_poa',
  REVISE_DOCUMENTS = 'revise_documents',
  PRE_CUSTOMER_MEETING_WORK = 'pre_customer_meeting_work',
  AOE_COMMUNICATION = 'aoe_communication',
  GUIDANCE_MEETING = 'guidance_meeting',
  INTAKE_MEETING_NEW = 'intake_meeting_new',
  AUDIT_REVIEW = 'audit_review',
  AUDIT_REQUIRED_ACTION = 'audit_required_action'
}
